export const STEPS = {
    PERSON_SEARCH: 'person-search',
    PERSON_CREATION: 'person-creation',
    PERSON_MODIFICATION: 'person-modification',
    POLICIES: 'policies',
    OFFER: 'offer',
    INSTALLMENTS: 'installments',
    OTP_CREATION: 'otp-creation',
    OTP_DELIVERY: 'otp-delivery',
    FORM_VALIDATION: 'form-validation',
    OTP_VALIDATION: 'otp-validation',
    PERSON_COMPLETION: 'person-completion',
    CONFIRMAR_OPERACION: 'confirmar-operacion',
    GUARDAR_PRESTAMO: 'guardar-prestamo',
    OBTENER_IMPRESION_DE_SOLICITUD: 'obtener-impresion-de-solicitud',
    DIVIDIR_PDF: 'dividir-pdf',
    CREAR_PERSONA_CUOTITAS: 'crear-persona-cuotitas',
    CREAR_FIRMA: 'crear-firma',
    GUARDAR_FIRMA: 'guardar-firma',
    CREAR_LINK_DE_FIRMA: 'crear-link-de-firma',
    ENVIAR_LINK_FIRMA: 'enviar-link-firma',
};
